// extracted by mini-css-extract-plugin
module.exports = {"stickyBar":"WhatNew_stickyBar__VRVO4"};